export const BUILD_PATH = "customer/"; 
export const BUILD_PATH_COUNT = BUILD_PATH.length; //Build path character count
export const DEFAULT_OPTION = "";
export const BASE_URL = //"https://advancedmulch.com/";
"https://staging.advancedmulch.com/";
//"http://localhost:8081/";

export const UPFLOW_URL = `${BASE_URL}AdvancedMulch_api`;

export const URL = `${BASE_URL}AdvancedMulch_api/index.php`;

export const SERVER_URL = window.location.origin + "/" + BUILD_PATH;

export const DATE_FORMAT = "DD-MMM-YYYY";
export const DATE_FORMAT_UPDATED = "MM/DD/YYYY";

export const APP_BASE_URL_METHOD = "POST";
export const APP_FOOTER = `Copyright © ${new Date().getFullYear()} KeeneSystems.com`;

export const COMPANY_LOGO_ALT = "Advanced Mulch";

export const BENCHMARK_CONTACT = "BENCHMARK_CONTACT";
export const BENCHMARK_ORGANISATION = "BENCHMARK_ORGANISATION";
export const BENCHMARK_CONTACTLIST = "BENCHMARK_CONTACTLIST";
export const BENCHMARK_INSTALLATIONLIST = "BENCHMARK_INSTALLATIONLIST";
export const BENCHMARK_INVOICING_LIST = "BENCHMARK_INVOICING_LIST";
export const BENCHMARK_INVOICING_PRINT = "BENCHMARK_INVOICING_PRINT";
export const BENCHMARK_PROPERTIES = "BENCHMARK_PROPERTIES";
export const BENCHMARK_QUOTES = "BENCHMARK_QUOTES";
export const BENCHMARK_SCHEDULING = "BENCHMARK_SCHEDULING";
export const BENCHMARK_SCHEDULINGCOMPLETED = "BENCHMARK_SCHEDULINGCOMPLETED";
export const BENCHMARK_SCHEDULINGPRODUCTS = "BENCHMARK_SCHEDULINGPRODUCTS";

export const BENCHMARK_SINGLECONTACT = "BENCHMARK_SINGLECONTACT";
export const BENCHMARK_SINGLEAPPROVALQUOTE = "BENCHMARK_SINGLEAPPROVALQUOTE";
export const BENCHMARK_SINGLEREQUESTEDCHANGE =
  "BENCHMARK_SINGLEREQUESTEDCHANGE";
export const BENCHMARK_SINGLEMAP = "BENCHMARK_SINGLEMAP";

export const LOGIN_URL = "/login";

export const LOGIN_API = "LOGIN_API";
export const RESET_API = "RESET_API";
export const RESET_API_TOKEN = "RESET_API_TOKEN";

export const FORGOT_PASSWORD_API = "FORGOT_PASSWORD_API";
export const CHANGE_PASSWORD_API = "CHANGE_PASSWORD_API";

export const dateFormat = "dd-MM-yyyy";
